export default {
    home: 'home',
    taxdocuments: 'tax-documents',
} as const;
